export default __webpack_public_path__ + "static/media/transportbus5.e2ebb754.png";